import { ErrorPayload } from 'frontend-container/components/Menu/components/ChangePasswordModal/domain/interfaces';

import { createAction } from '@ac/library-utils/dist/redux-utils';

export const clearErrors = createAction<undefined>('CLEAR_ERRORS');

export const addError = createAction<ErrorPayload>('ADD_ERROR');
